export default import.meta.ROLLDOWN_FILE_URL_EZkHyp3THfFsQutBqX6ozA